import axios from "axios";
import endpoints from "../config/endpoints";
import { IUnsubscribe } from "../models/unsubscribe.model";

const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}
export async function getUserPhoto(photoType: number): Promise<any> {
    const token = getCookie("apinew-token");
    if (!token) throw new Error("Brak tokenu");


    const response = await axios.get(endpoints.user.photo + "/" + photoType, {
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
}
export async function newsletterUnsubscribe(payload: IUnsubscribe): Promise<any> {
    const response = await axios.post(endpoints.user.newsletter_unsubscribe, payload, {});
    return response.data;
}